import type {
  OnboardingModule,
  OnboardingState,
  OnboardingMutationTree,
  OnboardingActionTree,
  OnboardingGetterTree,
} from '@/store/@types/onboarding';

import { getOnboardingQuestions } from '@/api/onboarding';
import { getSubscriptionsProducts } from '@/api/subscriptions';

const state: OnboardingState = {
  questions: [],
  subscriptions: [],
  currentStep: 1,
};

const mutations: OnboardingMutationTree = {
  SET_QUESTIONS(state, data) {
    state.questions = data;
  },

  SET_SUBSCRIPTIONS(state, data) {
    state.subscriptions = data;
  },

  SET_CURRENT_STEP(state, data) {
    state.currentStep = data;
  },
};

const actions: OnboardingActionTree = {
  async getQuestions({ commit }) {
    const questions = await getOnboardingQuestions();

    commit('SET_QUESTIONS', questions);
  },

  async getSubscriptions({ commit }) {
    const subscriptions = await getSubscriptionsProducts();

    commit('SET_SUBSCRIPTIONS', subscriptions);
  },

  setCurrentStep({ commit }, step) {
    commit('SET_CURRENT_STEP', step);
  },
};

const getters: OnboardingGetterTree = {
  extendedQuestions(state) {
    return state.questions;
  },

  filteredSubscriptions(state) {
    const descrMapper: Record<string, string> = {
      Lifetime: 'one time payment',
      Weekly: '3 days free trial',
      Yearly: '$0.67/week',
    };

    return state.subscriptions
      .filter((sub) => !sub.screens.includes('lifetime_lto'))
      .map((sub) => ({
        ...sub,
        descriptionAlt: descrMapper[sub.name] ?? sub.description,
      }));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as OnboardingModule;
